export default __webpack_public_path__ + "static/media/tokiKitSelection@2x.f37e1ea1.png";